import { render } from "./SlotVsDepositByShareholder.vue?vue&type=template&id=44aed244"
import script from "./SlotVsDepositByShareholder.vue?vue&type=script&lang=js"
export * from "./SlotVsDepositByShareholder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__